import { render, staticRenderFns } from "./importResource.vue?vue&type=template&id=2f9cebc3&scoped=true"
import script from "./importResource.vue?vue&type=script&lang=js"
export * from "./importResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9cebc3",
  null
  
)

export default component.exports